import * as React from "react";
import {UserListElement} from "./components/UserListElement";
import {EmptyState, infoIcons, Spinner} from "@vebox/etui-core";
import {Display} from "../components/Display";
import {UserListContext} from "./contexts/UserListContext";
import {AppTranslations} from "../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;


export const UsersList: React.FC<any> = () => {
    const {usersList, totalUser, isLoading, getUsersList, isFistRender, filtersUpdated} = React.useContext(
        UserListContext)

    const onScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
        const {scrollTop, scrollHeight, clientHeight} = event.currentTarget;
        if (scrollTop + clientHeight >= (scrollHeight - 156) && usersList.length < totalUser && !isLoading) {
            getUsersList(usersList.length);
        }
    };

    React.useEffect(() => {
        if (!isFistRender && !filtersUpdated) {
            getUsersList(0, false);
        }
    }, [])

    return (
        <div className={"users-list"} onScroll={onScroll}>
            <Display isVisible={usersList.length > 0}>
                {usersList.map((user) => {
                        return <UserListElement key={user.guid} user={user}/>
                    }
                )}
            </Display>
            <Display isVisible={usersList.length === 0 && !isLoading}>
                <EmptyState>
                    <EmptyState.InfoIcon
                        styles={{
                            root: {
                                color: "inherit",
                            }
                        }}
                        glyph={infoIcons.NoContent}
                    />
                    <EmptyState.Title color="inherit">{AppTranslations.listManager.descriptionNoElement}</EmptyState.Title>
                    <EmptyState.SubTitle color="inherit">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                </EmptyState>
            </Display>
            <Display isVisible={isLoading}>
                <Spinner/>
            </Display>
        </div>
    )
}